import React, { useState, useEffect } from 'react';
import '../styles/Inicio.css';
import { useNavigate } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';

// Imágenes por defecto
const defaultImages = [
  '/assets/barco.jpg',
  '/assets/contenedor.jpg',
];

const Inicio = () => {
  const [banners, setBanners] = useState(defaultImages);
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  // 1. Cargar banners desde el Backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/Banner`)
      .then(res => res.json())
      .then(data => {
        if (data.banner_urls && Array.isArray(data.banner_urls) && data.banner_urls.length > 0) {
          setBanners(data.banner_urls);
        }
      })
      .catch(err => {
        console.error("Error al cargar banners dinámicos, usando locales:", err);
      });
  }, []);

  // 2. Rotación automática
  useEffect(() => {
    if (banners.length <= 1) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [banners]);

  return (
    <div className="inicio-container">
      
      {/* Carrusel */}
      <div className="carousel-container">
        <img
          src={banners[index]}
          alt={`Imagen ${index + 1}`}
          className="carousel-image"
        />

        {index === 0 && (
          <div className="carousel-overlay">
            <h1>¿NECESITAS IMPORTAR O EXPORTAR MERCANCÍA?</h1>
            <p>Nosotros te ayudamos.</p>
            <button 
              className="btn-cotizar" 
              onClick={() => navigate('/calculo')}
            >
              Cotizar costos
            </button>
          </div>
        )}

        <div className="carousel-dots">
          {banners.map((_, i) => (
            <span
              key={i}
              className={`dot ${index === i ? 'active' : ''}`}
              onClick={() => setIndex(i)}
            ></span>
          ))}
        </div>
      </div>

      <div className="main-content">
        
        {/* Sección Acerca De */}
        <section className="acerca-section">
            <h2 className="section-title">ACERCA DE</h2>
            <div className="acerca-logo-container">
                <img src="/assets/logo_see.png" alt="Logo SeeLogis" className="acerca-logo"/>
            </div>
            <p className="texto-introduccion">
            <strong>See logis</strong> proporciona información sobre logística de puertos dirigida a MIPYMES importadoras y
            exportadoras de productos que tengan la necesidad de contar con la información para mover
            sus mercancías. Cuenta con una base de datos de aseguradoras, corredores públicos, costos
            arancelarios, empresas de envase y empaque y embalaje e información internacional de
            movimiento de productos, el tipo de puerto o aduana en la que puede manejar sus mercancías.
            </p>
        </section>

        {/* Sección Catálogo CORREGIDA */}
        <section className="catalogo-section">
            <h2 className="section-title">Contamos con un amplio catálogo de empresas</h2>
            <p className="section-subtitle">Explore nuestras categorías para encontrar el socio logístico perfecto para sus necesidades.</p>
            
            <div className="catalogo-grid">
                {/* Tarjeta 1: Agencias */}
                <div className="catalogo-card" onClick={() => navigate('/agencias', { state: { tipo: 'Agente Aduanal'} })}>
                    <img src="/assets/custom.png" alt="Agencias aduanales" className="card-icon" />
                    <span>Agencias aduanales</span>
                </div>
                
                {/* Tarjeta 2: Aseguradoras */}
                <div className="catalogo-card" onClick={() => navigate('/agencias', { state: { tipo: 'aseguradora'} })}>
                    <img src="/assets/insurance.png" alt="Aseguradoras" className="card-icon" />
                    <span>Aseguradoras</span>
                </div>

                {/* Tarjeta 3: Corredores */}
                <div className="catalogo-card" onClick={() => navigate('/agencias', { state: { tipo: 'Corredor público'} })}>
                    <img src="/assets/lawyer2.png" alt="Corredores públicos" className="card-icon" />
                    <span>Corredores públicos</span>
                </div>

                {/* Tarjeta 4: Transporte Terrestre */}
                <div className="catalogo-card" onClick={() => navigate('/transportistas', { state: { tipo: 'terrestre' } })}>
                    <img src="/assets/shipping2.png" alt="Transporte terrestre" className="card-icon" />
                    <span>Transporte terrestre</span>
                </div>

                {/* Tarjeta 5: Transporte Ferroviario */}
                <div className="catalogo-card" onClick={() => navigate('/transportistas', { state: { tipo: 'ferrocarril' } })}>
                    <img src="/assets/ferrocarril.png" alt="Transporte ferroviario" className="card-icon" />
                    <span>Transporte ferroviario</span>
                </div>

                {/* Tarjeta 6: Agente Naviero */}
                <div className="catalogo-card" onClick={() => navigate('/agencias', { state: { tipo: 'Agente Naviero' } })}>
                    <img src="/assets/ship.png" alt="Agentes Navieros" className="card-icon" />
                    <span>Agentes Navieros</span>
                </div>
            </div>
        </section>

        {/* Sección Ruta Logística */}
        <section className="ruta-section">
            <h2 className="section-title">Mi ruta logística</h2>
            <p className="ruta-description">
            Proporciona una guía a las empresas que deseen realizar importaciones o exportaciones de
            mercancías al extranjero, mostrando la documentación necesaria para realizar dicho proceso, así
            como también muestra una cotización aproximada del costo total.
            </p>

            <div className="ruta-opciones">
                <div className="opcion" onClick={() => navigate('/importacion')}>
                    <div className="circle-btn red-border">
                        <img src="/assets/flecha_roja.png" alt="Importar" />
                    </div>
                    <span className="opcion-text">Quiero importar</span>
                </div>
                <div className="opcion" onClick={() => navigate('/exportacion')}>
                    <div className="circle-btn yellow-border">
                        <img src="/assets/flecha_amarilla.png" alt="Exportar" />
                    </div>
                    <span className="opcion-text">Quiero exportar</span>
                </div>
            </div>
        </section>

      </div>
    </div>
  );
};

export default Inicio;
